export function getAllPermissions() {
  return {
    MANAGEMENT_USER: 2,
    MANAGEMENT_ROLE: 3,
    FileUpLoader: 4,
    MANAGEMENT_VEHICLE: 5,
    MANAGEMENT_VEHICLE_GROUP: 6,
    MANAGEMENT_DRIVER: 7,
    SupportContract: 8,
    MapViewVPath: 15,
    MapViewSimple: 17,
    MapViewVOnline: 21,
    ArbaeenReports: 22,
    HeatMap: 23,
    TOOLS_CONFIGURATION: 24,
    TRACKER_TEST_VIEW: 25,
    TRACKER_TEST_EDIT: 26,
    DashBoard: 27,
    DashCam: 28,
    GeneralConfig: 30,
    ChangeOnlineReportSettings: 31,
    WEB_ONLINE_USERS: 33,
    WEB_ADMIN_CONFIG: 34,
    WEB_ENTERANCE_REPORT: 35,
    WEB_DELETE_REPORT_HISTORY: 36,
    EDIT_DefinePerson: 71,
    EDIT_MANAGEMENT_SENSORMODEL: 72,
    EDIT_MANAGEMENT_SENSORS: 76,
    EDIT_MANAGEENT_ASSIGNED_SERVICE: 77,
    EDIT_MANAGEMENT_SERVICE: 78,
    EDIT_VehicleSupportCompany: 79,
    AccessPOL: 108,
    MANAGEMENT_AREA: 109,
    MANAGEMENT_GEO_PROPERTY: 110,
    MANAGEMENT_GEO_PERMISSION: 111,
    MANAGEMENT_ALARM: 112,
    AccessResetTamper: 113,
    AccessResetFactory: 114,
    AccessSendController: 115,
    RELATION_ALARM_VEHICLE: 116,
    RELATION_ALARM_USER: 117,
    RELATION_USER_VEHICLEGROUP: 118,
    RELATION_USER_VEHICLE: 119,
    RELATION_USER_ROLE: 120,
    CHANGE_USER_PASSWORD: 121,
    ROLE_ACCESSITEM: 122,
    EDIT_MANAGEMENT_AREA: 123,
    RELATION_VEHICLE_VEHICLEGROUP: 124,
    EDIT_MANAGEMENT_PATH: 125,
    MANAGEMENT_VEHICLEMODEL: 126,
    MANAGEMENT_ASSIGNEDAREA: 127,
    MANAGEMENT_ASSIGNEDAREA_ORDERING: 128,
    Edit_Trackers: 129,
    MANAGEMENT_PATH: 131,
    MANAGEMENT_POI: 132,
    MANAGEMENT_SENSORS: 133,
    MANAGEMENT_SENSORMODEL: 134,
    MANAGEMENT_SENSORUSAGE: 135,
    MANAGEMENT_VEHICLEKIND: 136,
    MANAGEMENT_SERVICE: 138,
    PMSERVICEHISTORY: 139,
    CHANGE_SPECIAL_PERMISSIONS: 140,
    MANAGEENT_ASSIGNED_SERVEICE: 141,
    CHANGE_USER_TYPE: 142,
    Manage_AccountEntity: 145,
    MANAGEMENT_OUTPINUSAGES: 146,
    OUTPINS_VEHICLESETTINGS: 147,
    Manage_Accounts: 148,
    AddMarkerInMapViewVPath: 150,
    DefinePerson: 151,
    RELATION_VEHICLE_PATH_ASSIGNED: 152,
    RELATION_VEHICLE_POINT_ASSIGNED: 153,
    EDIT_MANAGEMENT_VEHICLEMODEL: 154,
    EDIT_MANAGEMENT_VEHICLEKIND: 155,
    VIEW_ONLINE_REPORT_SETTING: 158,
    EDIT_RELATION_VEHICLE_PATH_ASSIGNED: 160,
    EDIT_MANAGEMENT_POI: 161,
    EDIT_RELATION_VEHICLE_POINT_ASSIGNED: 162,
    EDIT_MANAGEMENT_USER: 163,
    EDIT_RELATION_USER_ROLE: 164,
    EDIT_RELATION_USER_VEHICLE: 165,
    EDIT_RELATION_USER_VEHICLEGROUP: 166,
    EDIT_RELATION_VEHICLE_VEHICLEGROUP: 167,
    EDIT_RELATION_ALARM_VEHICLE: 168,
    EDIT_MANAGEMENT_DRIVER: 170,
    EDIT_MANAGEMENT_GEO_PROPERTY: 171,
    EDIT_MANAGEMENT_GEO_PERMISSION: 172,
    EDIT_RELATION_ALARM_USER: 174,
    Edit_MANAGEMENT_OUTPINUSAGES: 175,
    EDIT_MANAGEMENT_SENSORUSAGE: 176,
    EDIT_MANAGEMENT_ALARM: 177,
    EDIT_OUTPINS_VEHICLESETTINGS: 178,
    Report: 179,
    EDIT_ROLE: 181,
    EDIT_ROLE_ACCESSITEM: 182,
    EDIT_MANAGEMENT_VEHICLE_GROUP: 183,
    EDIT_MANAGEMENT_ASSIGNEDAREA: 184,
    SendAlarmToPersons: 185,
    EditSendAlarmToPersons: 186,
    MANAGEMENT_VEHICLE_Vehicle_SPEC: 187,
    ReportBuilder: 190,
    EditReportBuilder: 191,
    DefineCustomProperty: 192,
    AllUserManagement: 193,
    Manage_Company: 195,
    DepartmentManagement: 196,
    Test: 197,
    ImportTrackerList: 198,
    DownloadHelpFile: 199,
    TrackerStopReason: 200,
    Edit_TrackerStopReason: 201,
    Mission: 202,
    Edit_Mission: 203,
    VisitForm: 204,
    Edit_VisitForm: 205,
    Winter: 206,
    Edit_Winter: 207,
    View_TrackersResult: 208,
    View_Shelters: 209,
    MachineFailureReason: 212,
    Edit_Shelters: 216,
    TrackerStopReason_SetDisable: 210,
    View_All_Vehicles_OnlineReports: 211,
    TrackerDetail: 214,
    SimCardView: 215,
    ConsumptionVehicle: 217,
    RoadsMngConfirmation: 218,
    MachineryMngConfirmation: 219,
    SQLEditor: 255,
    AlarmReport: 10002,
    StopReport: 10004,
    DistanceReportNewest: 10030,
    VehiclePath: 10037,
    VehicleGPSAllPointsInRangeDates: 10038,
    OverSpeedHistoryReport: 10063,
    AreaActivityReport: 10066,
    CommandsStatus: 10071,
    AreaVehicleDetailReport: 10082,
    AreaActivityByProvince: 10083,
    BillingReport: 10084,
    CurrentStatus: 10085,
    DeviceTrackerLastStatus: 10086,
    TrackerBillingReport: 10087,
    SupporterBillingDetailReport: 10088,
    SupporterBillingReport: 10089,
    ConsultantBillingReport: 10090,
    ProvinceSpeedAverage: 10091,
    CountrySpeedAverage: 10092,
    TrackerTestReport: 10093,
    Contracts: 10094,
    DistanceActiveHoursReport: 10095,
    OverSpeedActiveHoursReport: 10096,
    DistanceReportInArea: 10097,
    InactiveTrackers: 10098,
    DeviceTrackerLastStatus2: 10099,
    VehiclesMissionReport: 10100,
    DepartmentsMissionReport: 10101,
    IncorrectOperationReport: 10102,
    VehiclesMissionAndDistanceReport: 10103,
    ConsumptionVehicleReport: 10104,
    DefinedMissionsReport: 10105,
    IncorrectStatusReport: 10106,
    SupporterEvaluationReport: 10107,
    TrackersWithoutDataReport: 10108,
    ActiveTrackersDailyReport: 10109,
    ActiveInstalledTrackersDailyReport: 10110,
    TrackerInstallationReport: 10111,
    UserActivitiesReport: 10112,
    TrackerLifeReport: 10115,
    CameraStatusReport: 10118
  };
}

export function hasPermissions(permissions, permittedUsecases){
  return permissions.every(c =>
    permittedUsecases.includes(c)
  );
}
